import { createContext, type Dispatch, type SetStateAction, use } from 'react';

import { PrivacyPolicySignStatusDto } from '@/api/generated/models/privacy-policy-sign-status-dto';
import { type UserBasicDto } from '@/api/generated/models/user-basic-dto';
import { RouteEnum } from '@/layouts/routes/Route.model.ts';
import { emptyFunction } from '@/utils/emptyFunction.util.ts';

export type UserModel = Omit<UserBasicDto, 'id'> & {
  dataReady: boolean;
  defaultPath: RouteEnum;
  fullName: string;
  userId: string;
  userProfileId?: string;
};

export const UserDefault: UserModel = {
  companyName: undefined,
  dataReady: false,
  defaultPath: RouteEnum.ROOT,
  email: '',
  firstName: '',
  fullName: '',
  initializationDone: false,
  lastName: '',
  permissions: [],
  privacyPolicyStatus: PrivacyPolicySignStatusDto.NotSigned,
  userId: '',
  userProfileId: undefined,
};

export const UserDefaultValues: UserContextProps = {
  setUser: emptyFunction,
  user: UserDefault,
};

export type UserContextProps = {
  setUser: Dispatch<SetStateAction<UserModel>>;
  user: UserModel;
};
export const UserContext = createContext<UserContextProps>(UserDefaultValues);

export const useUserContext = (): UserContextProps => {
  return use(UserContext);
};
